function replaceCell(cell, scope) {
  const header = document.createElement('th');
  for (const attribute of cell.attributes) {
    header.setAttribute(attribute.name, attribute.value);
  }
  header.scope = scope;
  while (cell.firstChild) header.appendChild(cell.firstChild);
  cell.replaceWith(header);
}

function enhanceSizeTables(root = document) {
  const selector =
    "main[data-template^='product'] .product-details .table-responsive table:not([data-ktt-table-headers])";

  for (const table of root.querySelectorAll(selector)) {
    const rows = Array.from(table.rows);
    if (rows.length < 2 || rows[0].cells.length < 2 || table.querySelector('th')) continue;

    for (const cell of Array.from(rows[0].cells)) replaceCell(cell, 'col');
    for (const row of rows.slice(1)) {
      if (row.cells[0]) replaceCell(row.cells[0], 'row');
    }

    table.dataset.kttTableHeaders = 'true';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => enhanceSizeTables(), { once: true });
} else {
  enhanceSizeTables();
}

document.addEventListener('shopify:section:load', (event) => {
  enhanceSizeTables(event.target);
  scheduleHiddenFocus(event.target);
});

const hiddenFocusState = new Map();
const managedHiddenContainers = new Set();
const pendingHiddenRoots = new Set();
let hiddenFocusFrame = 0;
const focusableSelector = [
  'a[href]',
  'button',
  'input',
  'select',
  'textarea',
  'summary',
  'iframe',
  '[tabindex]',
  '[contenteditable="true"]',
  'audio[controls]',
  'video[controls]'
].join(',');

function suppressHiddenFocus(container) {
  container.inert = true;
  managedHiddenContainers.add(container);
  const focusables = [];
  if (container.matches(focusableSelector)) focusables.push(container);
  focusables.push(...container.querySelectorAll(focusableSelector));

  for (const element of focusables) {
    if (!hiddenFocusState.has(element)) {
      hiddenFocusState.set(element, element.getAttribute('tabindex'));
    }
    element.setAttribute('tabindex', '-1');
  }
}

function restoreVisibleFocus() {
  for (const [element, originalTabindex] of hiddenFocusState) {
    if (!element.isConnected) {
      hiddenFocusState.delete(element);
      continue;
    }
    if (element.closest('[aria-hidden="true"]')) continue;

    if (originalTabindex === null) element.removeAttribute('tabindex');
    else element.setAttribute('tabindex', originalTabindex);
    hiddenFocusState.delete(element);
  }
}

function restoreVisibleContainers() {
  for (const container of managedHiddenContainers) {
    if (!container.isConnected) {
      managedHiddenContainers.delete(container);
      continue;
    }
    if (container.matches('[aria-hidden="true"]') || container.closest('[aria-hidden="true"]')) continue;

    container.inert = false;
    managedHiddenContainers.delete(container);
  }
}

function flushHiddenFocus() {
  hiddenFocusFrame = 0;
  const hiddenContainers = new Set();

  for (const root of pendingHiddenRoots) {
    if (!root.isConnected) continue;

    const hiddenAncestor = root.closest('[aria-hidden="true"]');
    if (hiddenAncestor) hiddenContainers.add(hiddenAncestor);
    if (root.matches('[aria-hidden="true"]')) hiddenContainers.add(root);
    for (const container of root.querySelectorAll('[aria-hidden="true"]')) {
      hiddenContainers.add(container);
    }
  }

  pendingHiddenRoots.clear();
  for (const container of hiddenContainers) suppressHiddenFocus(container);
  restoreVisibleFocus();
  restoreVisibleContainers();
}

function scheduleHiddenFocus(root) {
  if (root instanceof Element) pendingHiddenRoots.add(root);
  if (hiddenFocusFrame) return;
  hiddenFocusFrame = requestAnimationFrame(flushHiddenFocus);
}

function initializeHiddenFocus() {
  for (const container of document.querySelectorAll('[aria-hidden="true"]')) {
    suppressHiddenFocus(container);
  }
}

initializeHiddenFocus();

const hiddenFocusObserver = new MutationObserver((records) => {
  for (const record of records) {
    if (record.type === 'attributes') {
      scheduleHiddenFocus(record.target);
      continue;
    }

    for (const node of record.addedNodes) {
      if (node instanceof Element) scheduleHiddenFocus(node);
    }

    if (record.removedNodes.length > 0) scheduleHiddenFocus();
  }
});

hiddenFocusObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ['aria-hidden'],
  childList: true,
  subtree: true
});

function reconcileProductVariantUrl(event) {
  const picker = event.target;
  const variantId = event.detail?.resource?.id;

  if (!(picker instanceof HTMLElement) || picker.tagName !== 'VARIANT-PICKER') return;
  if (picker.dataset.templateProductMatch !== 'true' || !variantId) return;
  if (picker.closest('product-card, quick-add-dialog') || event.detail?.data?.newProduct) return;

  const url = new URL(window.location.href);
  if (url.searchParams.get('variant') === String(variantId)) return;

  url.searchParams.set('variant', String(variantId));
  history.replaceState(history.state, '', url.toString());
}

// Horizon updates the URL before its variant-section request resolves. The
// latest successful response is authoritative, so reconcile after its
// abortable request completes to prevent rapid option changes leaving a stale URL.
document.addEventListener('variant:update', reconcileProductVariantUrl);
